import Information from './Information'
import Setting from './Setting'

const VPS = {
    Information,
    Setting,
}

export default VPS
